module.exports = __webpack_public_path__ + "img/Gibraltar.a797ad6f.png";